import invert from './invert';
import sortPageAlphabetical from './sortPageAlphabetical';
import sortPageChronological from './sortPageChronological';

export const sortByRanking = (a, b) => {
  // if (a.score > b.score) return -1;
  // if (a.score < b.score) return 1;
  const relevetantDateA = a.updatedAt || a.createdAt;
  const relevetantDateB = b.updatedAt || b.createdAt;
  if (new Date(relevetantDateA) < new Date(relevetantDateB)) return 1;
  if (new Date(relevetantDateA) > new Date(relevetantDateB)) return -1;
  return 0;
};

export { invert, sortPageAlphabetical, sortPageChronological };
